import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, FormHelperText, Grid, MenuItem, Select, SelectProps, Box, Typography, Paper, IconButton, Button } from '@mui/material';
import { FieldAttributes, Form, Formik, useField } from 'formik';
import { FMSelectTrueFalse } from '../Elements/select';
import { FMTextField } from '../Elements/input';
import useAuth from "../../context/AuthProvider";
import "react-datepicker/dist/react-datepicker.css";
import { StatesZeroFilingRuleModel, StatesZeroFilingRuleModel_VS } from '../../models/StatesZeroFilingRuleModel';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { apiClient } from '../../helper/api';

const selectFieldSx = {
  width: '100%',
  '& .MuiSelect-select': { padding: '14.5px 16px' },
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const textFieldSx = {
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
  '& .MuiInputBase-input': { padding: '5px 14px !important' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};

interface Iprops {
    StateZeroRuleMatrixCL: StatesZeroFilingRuleModel,
    handleClose: () => void,
    Open: boolean,
    handleSubmit: () => void
    initValues: StatesZeroFilingRuleModel
}

export const EditStateZeroFilingRuleMatrix: React.FC<Iprops> = ({ handleClose, Open, StateZeroRuleMatrixCL, handleSubmit, initValues }) => {
    const initialValues: StatesZeroFilingRuleModel = initValues ? StateZeroRuleMatrixCL : initValues;

    const { user } = useAuth();
    const token = user?.token;

    const FMSelectStateCustom: React.FC<FieldAttributes<SelectProps>> = ({
        variant,
        ...props
    }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";
        const { user } = useAuth();
        const token = user?.token;
        const initialdata = { stateId: 0, stateName: "" };
        const [States, setStates] = useState([initialdata]);
        const fetchData = () => {
            apiClient("/States/getStates", {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
            })
                .then((responseJson) => {
                    // Do something with the response
                    if (responseJson?.data != null) {
                        setStates(responseJson.data);
                    }
                    console.log("statesDAta", responseJson.data);
                })
        };
        useEffect(() => {
            fetchData();
        }, []);
        return (
            <FormControl error={!!errorText} fullWidth>
                <FormHelperText className="formtexthelper-heading">State</FormHelperText>
                <Select
                    {...field}
                    labelId="State-Select-Label"
                    label={null}
                    IconComponent={ExpandMoreIcon}
                    className="border-round"
                    sx={selectFieldSx}
                >
                    {States.map((state, key) => (
                        <MenuItem key={key} value={state.stateId}>
                            {state.stateName}
                        </MenuItem>
                    ))}
                </Select>
                {errorText && <FormHelperText error>{errorText}</FormHelperText>}
            </FormControl>
        );
    };


    return (
        <Dialog
            open={Open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 900,
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
        >
            <DialogTitle
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <RuleOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        State Zero Filings Rules
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleClose}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <Formik initialValues={initialValues}
                enableReinitialize={true}
                validateOnChange={true}
                validationSchema={StatesZeroFilingRuleModel_VS}
                onSubmit={(data, { setSubmitting }) => {
                    if (data.stateId <= "") {
                        alert("Please Select state");
                        return;
                    }



                    apiClient('/StatesZeroFilingRules/Edit',
                        {
                            method: 'POST',

                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            body: JSON.stringify(data)  // <-- Post parameters

                        })
                        .then((res) => {
                            if (!res) return
                            alert("Data successfully saved");

                            handleSubmit()
                            setSubmitting(true)
                        })
                }} >
                {({ values, isSubmitting, setFieldValue }) => (
                    <Form className='main-form overflow-auto'>
                        <DialogContent sx={{ width: '100%', p: '0px' , '& > .MuiGrid-root': { px: { xs: 2, sm: 3 }, py: 3 } }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                        Rule details
                                    </Typography>
                                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <FMSelectStateCustom autoWidth={true} name="stateId" />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Postal Abbv</FormHelperText>
                                                    <FMTextField name="postalAbbv" margin="dense" label={null} placeholder="Postal Abbv" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <FormControl fullWidth>
                                                    <FormHelperText className="formtexthelper-heading">Standard Abbv</FormHelperText>
                                                    <FMTextField name="standardAbbv" margin="dense" label={null} placeholder="Standard Abbv" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6} className='mt-3'>
                                                <FMSelectTrueFalse autoWidth={true} name="isElectronicSignature" label="Is Electronic Signature" />
                                            </Grid>
                                            <Grid item xs={12} md={6} className='mt-3'>
                                                <FMSelectTrueFalse autoWidth={true} name="isZeroFilingState" label="Is Zero Filing State" />
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                gap: 1.5,
                                borderTop: 1,
                                borderColor: 'divider',
                                backgroundColor: 'grey.50',
                                flexWrap: 'wrap',
                            }}
                        >
                            <Button
                                variant="outlined"
                                size="medium"
                                onClick={handleClose}
                                startIcon={<CloseOutlinedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    borderColor: '#e2e8f0',
                                    color: '#475569',
                                    '&:hover': {
                                        borderColor: '#2099d2',
                                        backgroundColor: '#2099d214',
                                        color: '#2099d2',
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                size="medium"
                                type="submit"
                                disabled={isSubmitting}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    backgroundColor: '#2099d2',
                                    '&:hover': { backgroundColor: '#176990' },
                                    px: 2.5,
                                }}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}


            </Formik>
        </Dialog>
    );
}
